/**
 * ResponsavelGrupoEconomicoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelGrupoEconomico} from '@/model/resource/ResponsavelGrupoEconomico'

@HttpExclude()
export class ResponsavelGrupoEconomicoCollection extends PageCollection<
  ResponsavelGrupoEconomico
> {
  constructor() {
    super(ResponsavelGrupoEconomico)
  }

  queryAsPage() {
    return this.listResponsavelGrupoEconomico()
  }

  async removeResponsavelGrupoEconomico(id1: number, id2: number) {
    return await Request.post(
      `/admin/responsavel-grupo-economico/remove/${id1}/${id2}`
    )
      .name('removeResponsavelGrupoEconomico')
      .asNumber()
      .getData()
  }

  async listIdsGrupoEconomico() {
    return await Request.get(`/admin/responsavel-grupo-economico/list-ids`, {
      params: this.params,
    })
      .name('listIdsResponsaveis')
      .asArrayOf(this)
      .getData()
  }

  async listResponsavelGrupoEconomico() {
    return await Request.get(`/admin/responsavel-grupo-economico`, {
      params: this.params,
    })
      .name('listResponsavelGrupoEconomico')
      .as(this)
      .getResponse()
  }

  async listCsvResponsavelGrupoEconomico() {
    return await Request.get(`/admin/responsavel-grupo-economico/csv`, {
      params: this.params,
    })
      .name('listCsvResponsavelGrupoEconomico')
      .as(this)
      .getResponse()
  }
}
